import type { ComponentProps, PropsWithChildren } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Breadcrumbs } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export type SIBreadcrumbsVariant = "default" | "compact" | "spaceBetween";

type Props = ComponentProps<typeof Breadcrumbs> & {
    variant?: SIBreadcrumbsVariant;
    className?: string;
    dataAutomation?: string;
};

const DEFAULT_STYLES = {
    padding: "12px 24px",
    background: colorsPalettes.carbon[0],
    width: "100%",
    boxShadow: "0px 3px 6px 0px #0E1E3E14",
    height: "60px",
};

const STYLES_BY_VARIANT = {
    default: DEFAULT_STYLES,
    compact: {
        padding: "18px 24px 0",
    },
    spaceBetween: {
        ...DEFAULT_STYLES,
        justifyContent: "space-between",
    },
};

export const SIBreadcrumbs = ({
    variant = "default",
    dataAutomation,
    className,
    children,
    ...breadcrumbsProps
}: PropsWithChildren<Props>) => {
    return (
        <Flex
            data-automation={dataAutomation}
            className={className}
            justifyContent="flex-start"
            alignItems="center"
            alignSelf="flex-start"
            gap="8px"
            position="relative"
            {...STYLES_BY_VARIANT[variant]}
        >
            <Breadcrumbs {...breadcrumbsProps} />

            {children}
        </Flex>
    );
};
